package one.healthium.login.ui.magic_link

import co.touchlab.kermit.Logger
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import one.healthium.domain.user.UserInteractor
import one.healthium.ui.common.event_producer.EventProducer
import one.healthium.ui.common.message.UiMessage
import one.healthium.ui.common.message.UiMessageManager
import one.healthium.ui.common.vm.BaseViewModel

class MagicLinkViewModel(
    private val userInteractor: UserInteractor,
) : BaseViewModel() {

    private val _state = MutableStateFlow(MagicLinkUiState())
    val state = _state.asStateFlow()

    val messages = UiMessageManager()

    val events = EventProducer<MagicLinkUiEvent>()

    fun onUsernameChanged(value: String) {
        _state.update { state -> state.copy(magicLinkUiOptions = state.magicLinkUiOptions.copy(username = value)) }
    }

    fun onSubmitClicked(options: MagicLinkUiOptions) {
        launch {
            try {
                _state.update { state -> state.copy(loading = true) }
                userInteractor.requestMagicLink(options.username)
                _state.update { state -> state.copy(loading = false) }
                events.trigger(MagicLinkUiEvent.OnMagicLinkSent)
            } catch (e: Exception) {
                Logger.e("signIn error", e)
                messages.add(UiMessage.throwable(e))
            } finally {
                _state.update { state -> state.copy(loading = false) }
            }
        }
    }
}